import { render, staticRenderFns } from "./TransferenciasEmpresa.vue?vue&type=template&id=081b2386&scoped=true&"
import script from "./TransferenciasEmpresa.vue?vue&type=script&lang=js&"
export * from "./TransferenciasEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./TransferenciasEmpresa.vue?vue&type=style&index=0&id=081b2386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b2386",
  null
  
)

export default component.exports